import UICalendar from 'ui-addon-calendars/calendar/UICalendar';
import UICalendarEvent from 'ui-addon-calendars/calendar/UICalendarEvent/CalendarEvent';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRawParamsForListRolloutProductUpdates } from '../hooks/useRawParamsForListRolloutProductUpdates';
import { useSetQueryParams } from '../../app/hooks/useSetQueryParams';
import { utcToRolloutOffsetLocal } from '../../app/utils/dateUtils';
import { useEffect, useMemo } from 'react';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import NoResultsMessage from './NoResultsMessage';
import { getRequestParamsForGetRolloutProductUpdates } from '../utils';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CalendarEventPopoverWrapper = ({
  rolloutId
}) => {
  const setQueryParams = useSetQueryParams();
  useEffect(() => {
    setQueryParams({
      rollout: String(rolloutId)
    });
    // eslint-disable-next-line
  }, [rolloutId]);
  return /*#__PURE__*/_jsx(_Fragment, {});
};
const ProductUpdatesCalendar = ({
  rolloutProductUpdates
}) => {
  const timeNow = I18n.moment();
  const rawParams = useRawParamsForListRolloutProductUpdates();
  const {
    calendarTimestamp
  } = rawParams;
  const paramsForGetRolloutProductUpdates = getRequestParamsForGetRolloutProductUpdates(rawParams);
  const displayTimestamp = calendarTimestamp ? I18n.moment(calendarTimestamp) : I18n.moment();
  const today = I18n.moment.utc({
    year: timeNow.year(),
    month: timeNow.month(),
    day: timeNow.date()
  }).hours(14).local().valueOf();
  const calendarWeekHasPUs = useMemo(() => {
    const minDate = utcToRolloutOffsetLocal(I18n.moment(Number(calendarTimestamp)).startOf('week')).valueOf();
    const maxDate = utcToRolloutOffsetLocal(I18n.moment(Number(calendarTimestamp)).endOf('week')).valueOf();
    return rolloutProductUpdates.find(update => update.releaseDate && update.releaseDate > minDate && update.releaseDate < maxDate);
  }, [calendarTimestamp, rolloutProductUpdates]);
  const EXCLUDED_FILTERS = ['limit', 'offset', 'recommended', 'startReleaseDate', 'endReleaseDate', 'rolloutState', 'sortReleaseDate'];
  const hasFilters = Object.keys(paramsForGetRolloutProductUpdates).filter(key => !EXCLUDED_FILTERS.includes(key)).some(key => paramsForGetRolloutProductUpdates[key] !== null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UICalendar, {
      applicationId: "productupdates-ui-updates-calendar",
      use: "WEEK",
      eventDisplay: ['all-day-events'],
      displayDay: displayTimestamp.dayOfYear(),
      displayMonth: displayTimestamp.month(),
      displayYear: displayTimestamp.year(),
      currentTime: timeNow.valueOf(),
      hourHeight: 0,
      children: rolloutProductUpdates.filter(update => update.releaseDate && !(update.rolloutState === 'LIVE' && utcToRolloutOffsetLocal(update.releaseDate).valueOf() > today)).map(update => {
        const localReleaseDate = utcToRolloutOffsetLocal(update.releaseDate).valueOf();
        return /*#__PURE__*/_jsx(UICalendarEvent, {
          allDay: true,
          start: localReleaseDate,
          end: localReleaseDate,
          title: update.title,
          popoverProps: {
            arrowSize: 'none',
            use: 'unstyled'
          },
          popoverContent: /*#__PURE__*/_jsx(CalendarEventPopoverWrapper, {
            rolloutId: update.rollout.id
          }),
          children: /*#__PURE__*/_jsx(Text, {
            as: "div",
            color: "text-core-default",
            paddingInlineStart: "100",
            paddingInlineEnd: "100",
            typography: "heading-25",
            children: update.title
          })
        }, update.id);
      })
    }), !calendarWeekHasPUs ? !hasFilters ? /*#__PURE__*/_jsx(ResultsMessage, {
      illustration: "empty-state-charts",
      illustrationProps: {
        width: 187
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.noScheduledProductUpdates"
      })
    }) : /*#__PURE__*/_jsx(NoResultsMessage, {
      category: "scheduled-for-release"
    }) : /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.calendar.scrollCalendar"
        })
      })
    })]
  });
};
export default ProductUpdatesCalendar;